import WidgetModule from "@eisinc/Overrides/Widgets/SavedOrderList/SavedOrderListTable";

export * from "@eisinc/Overrides/Widgets/SavedOrderList/SavedOrderListTable";

export default WidgetModule;
